import ContentModule from './ContentModule';

export default ContentModule;
